/* eslint-disable @typescript-eslint/no-explicit-any */
import { useAtom } from 'jotai';
import { useEffect } from 'react';
import { Noti, NotiAtom } from '../atoms/NotiAtom';
import { formatDate } from 'src/libs/utils/convert-date-to-string';

const useNoti = () => {
  const [notiData, setNotiData] = useAtom(NotiAtom);

  useEffect(() => {
    localStorage.setItem('Noti', JSON.stringify(notiData));
  }, [notiData]);

  const removeNoti = (notiId: number) => {
    setNotiData((prevNoti: Noti[]) =>
      prevNoti.filter((prod) => prod?.id !== notiId)
    );
  };

  const addNoti = (noti: Noti) => {
    const newNoti: Noti = {
      ...noti,
      id: Date.now(),
      createdAt: formatDate(new Date()),
      isReaded: false,
    };
    setNotiData((prevNoti: Noti[]) => [newNoti, ...prevNoti]);
  };

  const resetNoti = () => {
    setNotiData([]);
  };

  const checkIsNoti = (notiId: number) => {
    if (notiData && notiData.length > 0) {
      const data = notiData.filter((noti: any) => Number(noti?.id) === notiId);
      if (data && data.length > 0) {
        return true;
      }
      return false;
    }
    return false;
  };

  const countUnreadNoti = () => {
    return notiData.filter((noti) => !noti.isReaded).length;
  };

  const readAll = () => {
    setNotiData((prevNoti: Noti[]) =>
      prevNoti.map((noti) => ({ ...noti, isReaded: true }))
    );
  };

  return {
    notiData,
    setNotiData,
    addNoti,
    resetNoti,
    removeNoti,
    checkIsNoti,
    countUnreadNoti,
    readAll,
  };
};

export default useNoti;
